import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SortingState } from '@devexpress/dx-react-grid';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import get from 'lodash/get';
import { thunks } from '@redux/jobs';

const columnNameMapping = {
	job : {
		columnName   : 'job',
		propertyName : 'Job',
	},
	location : {
		columnName   : 'location',
		propertyName : 'Location',
	},
	date : {
		columnName   : 'date',
		propertyName : 'StartDateTime',
	},
};

class SortingStateContainer extends Component {
	constructor(props) {
		super(props);

		const { filter } = props;
		const columnNameMap = find(columnNameMapping, ['propertyName', filter.sortBy]);
		const columnName = get(columnNameMap, 'columnName', '');

		const sorting = [
			{
				columnName,
				direction : filter.asc ? 'asc' : 'desc',
			},
		];

		this.state = {
			sorting,
		};
	}

	static getDerivedStateFromProps(nextProps, lastState) {
		const columnNameMap = find(columnNameMapping, ['propertyName', nextProps.filter.sortBy]);
		const columnName = get(columnNameMap, 'columnName', '');

		const sorting = [
			{
				columnName,
				direction : nextProps.filter.asc ? 'asc' : 'desc',
			},
		];

		if (!isEqual(sorting, lastState.sorting)) return { sorting };

		return null;
	}

	shouldComponentUpdate = ({ columnExtensions }, { sorting }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(columnExtensions, lastProps.columnExtensions)
			|| !isEqual(sorting, lastState.sorting)
		);
	}

	onSortingChange = (sorting) => {
		const { applyCriteria } = this.props;
		const columnName = get(sorting, ['0', 'columnName']);
		const columnNameMap = find(columnNameMapping, ['columnName', columnName]);
		const propertyName = get(columnNameMap, 'propertyName', '');

		applyCriteria([
			{
				property : 'sortBy',
				value    : propertyName,
			},
		]);
	}

	render() {
		const { columnExtensions } = this.props;
		const { sorting } = this.state;

		return (
			<SortingState
				sorting={sorting}
				columnExtensions={columnExtensions}
				onSortingChange={this.onSortingChange}
			/>
		);
	}
}

const mapStateToProps = ({
	jobs: {
		filter : {
			sortBy,
			asc,
		},
	},
}) => ({
	filter : {
		sortBy,
		asc,
	},
});

const mapDispatchToProps = (dispatch) => ({
	applyCriteria : bindActionCreators(thunks, dispatch).applyCriteria,
});

SortingStateContainer.propTypes = {
	applyCriteria    : PropTypes.func.isRequired,
	columnExtensions : PropTypes.array,
	filter           : PropTypes.object.isRequired,
};

SortingStateContainer.defaultProps = {
	columnExtensions : [],
};

export default connect(mapStateToProps, mapDispatchToProps)(SortingStateContainer);
